import { get, sortBy } from 'lodash/fp';

import { normalizeTeamPosition as normalizeChallengeTeamPosition } from './decodeChallenge';

function normalizeTeamPosition(data) {
  return {
    // [MC] team position from my-lineups only has label and short_label
    // loadLineUp needs to load the team into a position by key
    key: data.key || data.short_label.toLowerCase(),
    abbr: data.short_label,
    label: data.label
  };
}

function decodeSelection({
  selection = {},
  slate: { games = [], is_leg: isLeg, rule_set: ruleSet } = {}
}) {
  const playersData = (selection.players || []).map(player => ({
    ...player,
    game: games.find(g => g.id === player.game_id || g.id === player.gameId),
    gameOrder:
      sortBy('start_time', games).findIndex(
        g => g.id === player.game_id || g.id === player.gameId
      ) + 1
  }));

  return {
    bonusSelections: selection.bonus_selections,
    players: isLeg ? sortBy('gameOrder', playersData) : playersData,
    teams: (selection.teams || []).map(team => ({
      ...team,
      position: team.position
        ? normalizeTeamPosition(team.position)
        : normalizeChallengeTeamPosition(get('selection_rules', ruleSet)),
      game: games.find(g => g.id === team.game_id),
      gameOrder: games.findIndex(g => g.id === team.game_id) + 1,
      isTeam: true
    }))
  };
}

function decodeLineup(data = {}, meta = {}) {
  let { slate } = data;

  if (Array.isArray(meta.slates)) {
    slate = meta.slates.find(({ id }) => id === data.slate_id) || data.slate;
  }

  let { selection } = data;

  if (Array.isArray(slate.players)) {
    const players = (get('selection.players', data) || []).map(p => {
      const playerData = (slate.players || []).find(sp => sp.id === p.id);
      return { ...playerData, ...p };
    });
    selection = { ...data.selection, players };
  }

  return {
    id: data.id,
    isRacing: !!get('is_leg', slate),
    favorite: !!data.featured,
    entryCount: data.entry_count,
    remainingSalary: data.remaining_salary,
    score: data.fantasy_score,
    selection: decodeSelection({ ...data, selection, slate }),
    selectionHash: data.selection_hash,
    slate,
    sportId: get('sports[0].id', slate),
    sportIcon: get('sports[0].icon', slate),
    status: data.status,
    totalPrize: data.total_winning,
    userEntry: data.current_user_entry,
    user: data.user
  };
}

export default decodeLineup;
